document.addEventListener('DOMContentLoaded', function() {
    function handleTileDisplay(framework, tileSelector) {
        const containerDivs = document.querySelectorAll('.our-approach-chevron__container > div');
        
        containerDivs.forEach(container => {
            const tiles = container.querySelectorAll(tileSelector);
            
            tiles.forEach(tile => {
                if(tile.classList.contains(framework)) {
                    tile.style.display = 'flex';
                } else {
                    tile.style.display = 'none';
                }
            });
        });
    }

    const selectionBlocks = document.querySelectorAll('.selection__inner--block');

    const activeBlock = document.querySelector('.selection__inner--block.active');
    if (activeBlock) {
        const framework = activeBlock.getAttribute('data-framework');
        handleTileDisplay(framework, '.frameworks__container--inner-tile');
        handleTileDisplay(framework, '.activities__container--inner-tile');
    }

    selectionBlocks.forEach(block => {
        block.addEventListener('click', function() {
            selectionBlocks.forEach(b => b.classList.remove('active'));
            block.classList.add('active');

            const framework = block.getAttribute('data-framework');
            handleTileDisplay(framework, '.frameworks__container--inner-tile');
            handleTileDisplay(framework, '.activities__container--inner-tile');
        });
    });
});

